import React from 'react'
import { MANAGE_ITEMS } from './experienceNavigation'
import {
  formatExperienceDateRange,
  getParticipantCount,
} from './experienceStatus'

const ExperienceManageRail = ({
  questDetail,
  activeKey,
  onSelect,
  notes = {},
}) => {
  const title = questDetail?.name || questDetail?.title || '—'
  const dateRange = formatExperienceDateRange(questDetail)
  const participantCount = getParticipantCount(questDetail)
  const metaParts = [
    dateRange,
    participantCount != null
      ? `${participantCount} participant${participantCount === 1 ? '' : 's'}`
      : null,
  ].filter(Boolean)

  return (
    <aside className='experience-rail'>
      <div className='experience-rail-label'>Manage experience</div>
      <nav className='experience-manage-links'>
        {MANAGE_ITEMS.map((item) => (
          <button
            key={item.key}
            type='button'
            className={`experience-rail-item${
              activeKey === item.key ? ' sel' : ''
            }`}
            onClick={() => onSelect(item.key)}>
            {item.label}
            <span className='experience-note'>
              {notes[item.key] != null ? notes[item.key] : '0'}
            </span>
          </button>
        ))}
      </nav>
      <div className='experience-manage-context'>
        <span className='experience-eyebrow'>Current experience</span>
        <b>{title}</b>
        <small>{metaParts.join(' · ') || '—'}</small>
      </div>
    </aside>
  )
}

export default ExperienceManageRail
